

















































































































































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import MemberShip from "@/store/entities/membership";
import moment from "moment";

@Component({
  components: {},
})
export default class MemberShipDetail extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({
    type: Number,
    default: () => {
      return 0;
    },
  })
  id: number;
  memberShip: MemberShip = new MemberShip();
  moment = moment;
  phoneNumber: string = "";
  teeTime: string | any = "";

  spinShow: boolean = false;
  sendRule = {
    phoneNumber: [
      {
        required: true,
        message: "请输入手机号",
        trigger: "blur",
      },
      {
        pattern: /^1[3456789]\d{9}$/,
        message: "手机号格式不正确",
        trigger: "blur",
      },
    ],
  };
  closeTable() {
    this.$emit("input", false);
    this.$emit("getPage");
  }
  save() {
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      console.log(this.id);
      if (this.id) {
        let reponse = await Ajax.get(
          "/api/services/app/Membership/Get?id=" + this.id
        );
        this.memberShip = reponse.data.result;
        console.log(this.memberShip, "me");
      }
    }
  }
}
